export interface IncludedItem {
  title: string
  body: string
}

export interface IncludedGroup {
  label: string
  note?: string
  items: IncludedItem[]
}

export const includedGroups: IncludedGroup[] = [
  {
    label: 'Setup Week',
    items: [
      {
        title: 'Deep-Dive Wellness Assessment',
        body: 'A full review of your training history, sleep, stress load, nutrition patterns, and what your actual week looks like. Not a form. A conversation that ends with me understanding how your life runs.',
      },
      {
        title: 'Schedule & Travel Pattern Audit',
        body: 'I map your calendar and your typical routes before we build anything, so the plan fits the life you already have.',
      },
      {
        title: 'Executive Assistant Integration',
        body: 'Your EA is brought into the loop in week one and stays there. Logistics, scheduling, and confirmations route through them, not through you.',
      },
      {
        title: 'Weekly Rhythm Establishment',
        body: 'Your standing call time and check-in day are set once and held. You never have to schedule anything again.',
      },
      {
        title: 'Initial Training Program Build',
        body: 'Built to your body, your equipment access, and your travel, not to a template.',
      },
      {
        title: 'Initial Nutrition & Metabolic Strategy',
        body: "Macro targets set inside a phase structure, with the reasoning explained once so you don't have to think about it again.",
      },
      {
        title: 'Travel Protocol Template',
        body: 'Built to your specific routes before your first trip, not after it.',
      },
    ],
  },
  {
    label: 'Your Weekly Operating System',
    items: [
      {
        title: 'Weekly Standing Strategy Call',
        body: 'Same time every week. Never skipped. I arrive with your next thirty days already reviewed and a prepared plan.',
      },
      {
        title: 'Weekly Written Check-In Review',
        body: 'You send a short structured update before the call. I read it beforehand, so the call is spent on decisions rather than catching up.',
      },
      {
        title: 'On-Call Adjustments',
        body: 'Real-time changes to training, nutrition targets, travel routines, recovery, and daily structure during demanding weeks. You never have to figure it out alone.',
      },
      {
        title: 'Programming Written Two to Four Weeks Ahead',
        body: 'Your training is built in advance and adjusted weekly against travel, stress, energy, and recovery.',
      },
      {
        title: 'Outside Workout Accommodation',
        body: 'Train with whoever you want. Play whatever you play. I rebalance the rest of the week on the back end so nothing compounds badly.',
      },
      {
        title: 'Phase-Based Nutrition Strategy',
        body: 'Stabilization, precision, metabolic expansion, and performance phases, adjusted weekly against compliance, hunger, recovery, travel, and high-pressure weeks.',
      },
    ],
  },
  {
    label: 'Travel & Environment Concierge',
    note: 'Delivered for every trip, within 24 hours of notice.',
    items: [
      {
        title: 'Hotel Gym Audit',
        body: "I find out what's actually in the gym at your hotel and adjust your training to match, before you land.",
      },
      {
        title: 'Local Gym Scouting',
        body: "Two to three vetted options near where you're staying, with the tradeoffs named.",
      },
      {
        title: 'Restaurant Shortlist',
        body: 'Three to six places per location that fit your current phase. A short list, not a search.',
      },
      {
        title: 'Circadian & Jet Lag Plan',
        body: 'Built to your specific route and arrival time.',
      },
      {
        title: 'Travel Training Plan',
        body: "Sessions that work with the equipment you'll actually have, at the length your schedule will actually allow.",
      },
      {
        title: 'Mid-Trip Follow-Up',
        body: 'I check in on energy and sleep in the first two days, without waiting for you to flag a problem.',
      },
    ],
  },
  {
    label: 'Coordination & Reporting',
    items: [
      {
        title: 'Full EA Coordination',
        body: 'Your assistant receives monthly priorities, weekly logistics, travel instructions, gym and meal lists, and confirmations for everything. You never play middleman.',
      },
      {
        title: 'Monthly Performance Review',
        body: 'A full look at sleep, energy, training consistency, nutrition compliance, stress patterns, and how travel actually affected the month.',
      },
      {
        title: 'Next-Month Strategy & Forecast',
        body: 'Wins, patterns, adjustments, and clear priorities for the month ahead, delivered to you and to your EA.',
      },
    ],
  },
]
